import { inject, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Data, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AlarisAuthService, AlarisProfileService, PROFILE_SERVICE_INJECTOR } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService {
	readonly currentRouteData = new BehaviorSubject<Data | null>(null);
	readonly parentRoute = new BehaviorSubject<ActivatedRouteSnapshot | null>(null);

	constructor(
		private readonly authService: AlarisAuthService,
		private readonly router: Router,
		@Inject(PROFILE_SERVICE_INJECTOR) private readonly profile: AlarisProfileService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (this.authService.logged) {
			this.currentRouteData.next(route.data);
			this.parentRoute.next(route.parent);
			const { permissions, permissionComparison } = route.data;
			if (permissions && !this.profile.allowed(permissions, permissionComparison)) {
				this.router.navigate(['']).then();
				return false;
			}
			return true;
		}

		this.currentRouteData.next(null);
		this.parentRoute.next(null);
		this.authService.logOut();
		return false;
	}
}

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(AuthGuardService).canActivate(route);
